export default "<p>\n    In the template editor, information about the category, the uploaded productdata and the templates can be found and edited. \n</p>"